import PropTypes from 'prop-types';
import React from 'react';
import CountUp from 'react-countup';
import Icon from 'shared/components/icon';
import Stamp, {BLACK, GREEN} from 'src/components/Stamp/Stamp';
import {withCommas} from 'shared/utils';
import styles from './normal-text-stamp.module.scss';
import {formatEarnings} from 'src/utils/formatters';

class NormalText extends React.Component {
  static propTypes = {
    difference: PropTypes.number.isRequired,
    animated: PropTypes.bool,
    showNewEarnings: PropTypes.bool,
    earnings: PropTypes.number,
    earningsDivisor: PropTypes.number,
    previousEarnings: PropTypes.number,
    showPerYearEarnings: PropTypes.bool,
    submitted: PropTypes.bool,
    maxStudentEarningsReached: PropTypes.bool,
  };

  getClassName = () => {
    const {difference, animated, showNewEarnings} = this.props;

    let className = 'college-earnings-normal-text-top-row';

    const increasedDifference = difference > 0;
    const scrollEarningsStyle = !showNewEarnings && animated && difference !== 0;
    const showNewEarningsStyle = showNewEarnings && animated && difference !== 0;

    if (showNewEarningsStyle) {
      className += ' show-new-earnings';
    }
    if (scrollEarningsStyle) {
      className += ' scroll-earnings ';
    }
    if (increasedDifference && scrollEarningsStyle) {
      className += 'green';
    }
    if (!increasedDifference && scrollEarningsStyle) {
      className += 'red';
    }

    return className;
  };

  amountText = () => {
    const {earnings, earningsDivisor, showPerYearEarnings, submitted} = this.props;
    if (!earningsDivisor || !showPerYearEarnings || submitted) return null;
    const earningsText = formatEarnings(earnings, earningsDivisor).termDescription();
    return <p className="college-earnings-normal-text-bottom-row">${earningsText}</p>;
  };

  render() {
    const {
      difference,
      animated,
      showNewEarnings,
      earnings,
      previousEarnings,
      maxStudentEarningsReached,
    } = this.props;

    const increasedDifference = difference > 0;

    if (animated && difference !== 0) {
      if (showNewEarnings) {
        const arrow = increasedDifference ? (
          <Icon
            iconType="arrow-alt-up"
            className="college-earnings-normal-text-arrow rm-arrow-up green"
          />
        ) : (
          <Icon
            iconType="arrow-alt-down"
            className="college-earnings-normal-text-arrow rm-arrow-down red"
          />
        );
        const animationClass = increasedDifference ? 'slide-up' : 'slide-down';
        return (
          <div className="college-earnings-normal-text">
            <p className={`${animationClass}  ${this.getClassName()}`}>
              {arrow}${withCommas(Math.round(difference))}
            </p>
          </div>
        );
      } else {
        return (
          <div
            className={`college-earnings-normal-text ${styles.earningContainer}`}
            data-testid="normal-text"
          >
            <div className={`college-earnings-normal-text-top-row ${styles.earningStampContainer}`}>
              <Stamp color={BLACK} className={styles.earningStampLeft}>
                <CountUp
                  start={Math.round(previousEarnings)}
                  end={Math.round(earnings)}
                  duration={1 + earnings / 20000}
                  useEasing
                  useGrouping
                  separator=","
                  prefix="$"
                />
              </Stamp>
            </div>
            {this.amountText()}
          </div>
        );
      }
    } else {
      return (
        <div className="college-earnings-normal-text" data-testid="normal-text">
          <div className="college-earnings-normal-text-top-row">
            <Stamp color={GREEN}>${withCommas(Math.round(earnings))}</Stamp>
          </div>
          {this.amountText()}
          {maxStudentEarningsReached && (
            <p className="college-earnings-display-max-has-met">Max earnings for this school met</p>
          )}
        </div>
      );
    }
  }
}

export default NormalText;
